import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TChangeHistoryApi } from './types';

export const changeHistory: TChangeHistoryApi = {
	getAuditLogs: (payload) =>
		http.post(endpoint.changeHistory.GET_AUDIT_LOGS, payload).then((response) => response.data),
	getAuditLogsByEm: (payload) =>
		http
			.post(endpoint.changeHistory.GET_AUDIT_LOGS_BY_EM(payload.id), payload.body)
			.then((response) => response.data),
	getAuditLogsByUser: (payload) =>
		http
			.post(endpoint.changeHistory.GET_AUDIT_LOGS_BY_USER(payload.userId), payload.body)
			.then((response) => response.data),
};
